import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MedicalRequest,
  MedicalRequestResponseData,
} from 'src/app/_models/PSP/medical-requests.model';
import { GenericResponse, Response, SuccessResponse } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root',
})
export class MedicationRequestService {
  selectedRequest: MedicalRequest;
  url = 'api/AdminPspMedicationRequests';
  insulinProgram = 'D-Pen';
  rocheCompany = 'Roche';
  getMedicationRequestsUrl: string = 'api/AdminPspMedicationRequests/GetMedicationRequests';
  exportSheetRequest : string = 'api/AdminExportExcelReports/ExportSheetRequest'

  cancelMedicationRequestUrl: string = 'api/AdminPspMedicationRequests/CancelPspMedicationRequest';
  // public requestById = new EventEmitter<MedicalRequest>();
  constructor(private http: HttpClient) {}

  getRequests(params): Observable<Response<MedicalRequestResponseData>> {
    return this.http.get<Response<MedicalRequestResponseData>>(
      this.getMedicationRequestsUrl,
      {
        params,
      }
    );
  }

  isRocheRequest(programName: string): boolean {
    return programName === this.rocheCompany;
  }

  isInsulinRequest(programName: string): boolean {
    return programName === this.insulinProgram;
  }

  setSelectedRequest(selectedReq: MedicalRequest): void {
    this.selectedRequest = selectedReq;
  }

  getSelectedRequest(): Observable<MedicalRequest> {
    return new Observable<MedicalRequest>((observer) => {
      observer.next(this.selectedRequest);
    });
  }

  addMedicationRequest(body: {
    subscriptionId: number;
    pspPharmacyId: number;
  }): Observable<Response<{ flag: boolean }>> {
    return this.http.post<Response<{ flag: boolean }>>(
      `${this.url}/AddMedicationRequest`,
      body
    );
  }

  addExportRequest(body: {
    sheetType: number;
    pageSize: number;
    companyId: number;
    isHomeDelivery:boolean
  }): Observable<Response<{ flag: boolean }>> {
    return this.http.post<Response<{ flag: boolean }>>(
      this.exportSheetRequest,
      body
    );
  }
  searchMedicationRequests(
    searchString,
    typeId,
    medicationRequestStatusIds,
    companyid,
    currentPage,
    pageSize
  ): Observable<Response<MedicalRequestResponseData>> {
    const params = {
      patientNameOrMobile: searchString,
      requestTypeId: typeId,
      medicationRequestStatusIds:medicationRequestStatusIds,
      companyId:companyid,
      currentPage: currentPage,
      pageSize: pageSize
    };
    return this.http.get<Response<MedicalRequestResponseData>>(
      this.url + '/SearchMedicationRequests',
      { params }
    );
  }

  routeToPharmacy(body): Observable<Response<{ flag: boolean }>> {
    return this.http.put<Response<{ flag: boolean }>>(
      this.url + '/RouteToPharmacy',
      body
    );
  }

  updateMedicationRequest(body): Observable<Response<{ flag: boolean }>> {
    return this.http.put<Response<{ flag: boolean }>>(
      this.url + '/UpdateMedicationRequest',
      body
    );
  }

  cancelMedicationRequest(requestId: number, cancellationReason: string): Observable<SuccessResponse>{
    let body = {
      pspMedicationRequestId: requestId,
      cancellationReason: cancellationReason
    };
    return this.http.put<SuccessResponse>(this.cancelMedicationRequestUrl, body);
  }
}
